import {
  FETCH_ADMIN_COURSE_TREE_REQUEST,
  FETCH_ADMIN_COURSE_TREE_SUCCESS,
  FETCH_ADMIN_COURSE_TREE_FAILURE,
} from "../Actions/adminCourseTreeAction";

const initialState = {
  loading: false,
  treeData: [],
  error: "",
};

const adminCourseTreeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_COURSE_TREE_REQUEST:
      return { ...state, loading: true };
    case FETCH_ADMIN_COURSE_TREE_SUCCESS:
      return { ...state, loading: false, treeData: action.payload, error: "" };
    case FETCH_ADMIN_COURSE_TREE_FAILURE:
      return { ...state, loading: false, treeData: [], error: action.payload };
    default:
      return state;
  }
};

export default adminCourseTreeReducer;
